module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAhBAMAAADE0v0eAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURUdwTBMeHhQiIhMeHhUfHxMfHxUfHxUrKxMeHhMeHtZvy8AAAAAJdFJOUwCrJZxK73sM1e2VXxgAAABySURBVBjTY2BQYoAD5pkGcLbmzIlI7JkCCDVIEpJIEowDLDEZWUIBymSJRLAzEWoKZ86cmQBhMnXOnBkCFXadOXMGVDUbUIU4hMkONG8aVIXGzJlTHRBGNyGMnlgADx+Y0aBwC0GEIcxokBpxRKAjwh8A3Cc1K9OuHagAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account_arrow1.png
// module id = NVBu
// module chunks = 1